import { createContext, useContext } from 'react';
import type { AmbilightContextValue } from './AmbilightContext';

export const AmbilightContext = createContext<AmbilightContextValue | null>(null);

export const useAmbilightContext = (): AmbilightContextValue => {
  const context = useContext(AmbilightContext);
  if (!context) {
    throw new Error('useAmbilightContext must be used within an AmbilightProvider');
  }
  return context;
};
